import React, { useState, useEffect } from "react";
import './Login.css'
import { Input, Password } from './usefulcomps/HexInput/InputBox'
import Button from './HexButton/button'
import Swal from "sweetalert2";
import Hexapi from './usefulcomps/HexAPI/Hexapi'
import Support from './Support'
import { Modal } from 'react-bootstrap'
import Logo from './images/logo.png'
import Urlencoder from './usefulcomps/Urlencoder';
import { LaptopWindows } from "@material-ui/icons";
import { Aesdecryption, Aesencryption } from './usefulcomps/Aes/Aes'
// sessionStorage.setItem("Apipathurl","https://web.lawcrux.com/");


export default function Login() {
  // React States
  // const [errorMessages, setErrorMessages] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  // const [isforget, setIsforget] = useState(false);
  const [isOpenSupport, setisOpenSupport] = useState(false);
  const [userlabelcolor, setuserlabelcolor] = useState("black")
  const [passlabelcolor, setpasslabelcolor] = useState("black")
  const [username, setusername] = useState("")
  const [password, setpassword] = useState("")
  const [isModalOpen, setisModalOpen] = useState(false)
  const decodeUrl = (data) => {
    console.log(data)
    if(data.includes("?")){
      if (data.split('?')[1] !== "") {
          console.log(data)
          let enctext = data.split('?')[1]
          try {
              let AesDec = Aesdecryption(enctext)
              return Urlencoder(data.split('?')[0] + '/' + btoa(AesDec))
          }catch(err){
              let dectext = `?${enctext}`
              return Urlencoder(data.split('?')[0]+'/'+dectext)
          }
          
      } else {
          return Urlencoder(data)
      }
    }
}
const [data, setdata] = useState(decodeUrl(window.location.href))
useEffect(() => {
  if(data !=undefined ){
    if(data.msg !=undefined){
      console.log(data.msg)
      Swal.fire({
        html: data.msg,
        confirmButtonColor: '#e1563f'
      })
    }
  }
}, [])

  // const [clientdetails, setpassword] = useState("")
  const generateUniqueId = (length) => {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
  const clientdetails = localStorage.getItem('auth_lawcrux_id') != undefined ? localStorage.getItem('auth_lawcrux_id') :  generateUniqueId(10)

  // const [globalcolor, setglobalcolor] = useState([])
  // useEffect(() => {
  //   if(sessionStorage.getItem("Apipathurl") == undefined){
  //     window.location.reload()
  //   }
  // }, [])
  const handleforget = (event) => {
    console.log(event)
    setisOpenSupport(true)
  }

  const setSessions = (str) => {
    console.log(str)
    str = str.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(' ', '')
    while (str.toLowerCase().includes('sessionstorage.setitem')) {
      let key = str.substring(str.indexOf('("') + 2, str.indexOf('",'))
      let value = str.substring(str.indexOf(',') + 2, str.indexOf('")'))
      sessionStorage.setItem(key, value);
      str = str.replace(`sessionStorage.setItem("${key}","${value}");`, '')
    }
  }



  const handleSubmit = (event) => {
    //Prevent page reload
    sessionStorage.removeItem('userid')
    event.preventDefault();
    console.log(username)
    console.log(password)

    if (username != "") {
      if (password != "") {
        // console.log(generateUniqueId(10))
        let obj = {
          url: `https://web.lawcrux.com/SuccessfullyV2.php`,
          username: `${username}`,
          password: `${password}`,
          clientdetails: `${clientdetails}`
        }
        Hexapi(obj).then(resp => {
          console.log(resp)
          localStorage.setItem("auth_lawcrux_id",clientdetails)
          if (resp[''][0]['command'] == 1) {
            setSessions(resp[0])
            console.log(resp[0])
            window.location.href = `${sessionStorage.getItem("url")}Homepage`
          } else if (resp[''][0]['command'] == 2) {
            setSessions(resp[0])
            let obj = {
              query: `[dbo].[Lawcrux_Web_Proc_User_Update_ClientDetails]
              @UserID ='{0}',
              @Details='{1}'`,
              queryArr: [`${sessionStorage.getItem('userid')}`, `${clientdetails}`]
            }
            Hexapi(obj).then(resp => {
              console.log(resp)
              if (resp[''][0]['command'] == 1) {
                window.location.href = `${sessionStorage.getItem("url")}Homepage`
              } else {
                Swal.fire({
                  html: resp[''][0]['msg'],
                  confirmButtonColor: '#e1563f'
                })
              }
              // window.location.href = `${sessionStorage.getItem("url")}Homepage`
            })
          } else {
            Swal.fire({
              html: resp[''][0]['msg'],
              confirmButtonColor: '#e1563f'
            })
          }
        })

      } else {
        Swal.fire({
          text: "Enter your Password",
          confirmButtonColor: '#e1563f'
        })
      }
    } else {
      Swal.fire({
        text: "Enter your Username",
        confirmButtonColor: '#e1563f'
      })
    }
  };

  // JSX code for login form
  const renderForm = (
    <div className="form">
      <form onSubmit={handleSubmit}>
        <div className="input-container">

          <Input
            labelStyle={{ fontWeight: "600", color: `${userlabelcolor}` }}
            label="Username"
            type="text"
            className="form-control"
            name="username"
            value={username}
            inline={false}
            onChange={(event) => setusername(event.target.value)}
          />

        </div>
        <div className="input-container">
          <Input
            labelStyle={{ fontWeight: "600", color: `${passlabelcolor}` }}
            label="Password"
            type="password"
            className="form-control"
            value={password}
            name="pass"
            inline={false}
            onChange={(event) => setpassword(event.target.value)}

          />

        </div>

        <div className="button-container">

          <Button buttonTitle="Submit" />
          <span onClick={handleforget} style={{ cursor: "pointer", width: "150px", margin: "15px", borderRadius: "10px", fontSize: "15px", fontWeight: "semi-bold", fontfamily: "system-ui" }}>Forget Password!!</span>
        </div>
      </form>
    </div>
  );
  const logoutFromOtherDevices = () => {
   
    
  }

  return (
    <>
      <div className="app" >
        {/* <div className="_LNavbar"> */}
        {/* <span>Lawcrux</span> */}
        {/* <img src={Logo} alt="" /> */}
        {/* <span style={{ width: "150px", margin: "15px", borderRadius: "10px", fontSize: "30px", fontWeight: "bold", fontfamily: "system-ui" }}>Lawcrux</span> */}
        {/* <img style={{ width: "150px", margin: "15px", borderRadius: "10px" }} src={process.env.PUBLIC_URL + "VMS.png"} /> */}
        {/* </div> */}
        <div className="appflex">
          <div className="_Lloginbox">
            <img src={Logo} alt="" />
            <div className="login-form" >

              <div className="title">LOGIN</div>
              {isSubmitted ? <div>You can achive your goal</div> : renderForm}
            </div>
          </div>



          {/* <div style={{ display: "flex", flexDirection: "column", margin: "30px" }}>
            <span style={{ fontWeight: "100" }}>Designed and Powered by</span>
            <img style={{ width: "150px", margin: "0px 0px 0px 20px" }} src={process.env.PUBLIC_URL + "HEX Logo.png"} />

          </div> */}
          <Modal
            id="modalcss"
            show={isModalOpen}
            onHide={() => setisModalOpen(false)}
            style={{ backgroundColor: "rgba(0,0,0,0.9)" }}
            centered
          >
            <Modal.Body>
              <div className="_cmd2Modal">
                <span onClick={() => logoutFromOtherDevices()}>
                  Logout from other devices
                </span>
                <span onClick={() => setisModalOpen(false)}>
                  Cancel
                </span>
              </div>

            </Modal.Body>

          </Modal>

          {
            isOpenSupport &&
            <Support
              openModal={isOpenSupport}
              closeModal={() => setisOpenSupport(false)}
              user={username}
            />
          }
        </div>
      </div>
    </>
  )
};